// The public links this app points at, in one place.
//
// The website renders them as a footer (`src/components/deck/Footer.tsx`); the desktop shell
// has no footer at all and repeats them in its Help menu and About panel — §14.7's "one chrome
// per runtime" again: a window that already has a native menu bar puts legal boilerplate in
// the menu, not in the document, where it would otherwise sit under every deck forever.
//
// `electron/menu.ts` cannot import from `src/` (separate project, separate build, nothing
// shared by design), so it carries its own copy. Change one, change both.
export const EXTERNAL_LINKS = {
  home: "https://www.griddtemplates.com/",
  privacy: "https://www.griddtemplates.com/privacy-policy",
  terms: "https://www.griddtemplates.com/terms",
} as const;

/** Shown in the web footer, and in the desktop About panel. */
export const COPYRIGHT = "© 2026 DeckAI Inc";
